module.exports = __webpack_public_path__ + "static/media/PaperPlane.1c9491e1.svg";